import {client} from "../axios/client";
import {types} from "../types/types";

const categoriesFetch = () => ({
    type: types.categoriesFetch,
});

const categoriesFetchSuccess = (categories) => ({
    type: types.categoriesFetchSuccess,
    payload: categories,
});

const categoriesFetchFailure = (error) => ({
    type: types.categoriesFetchFailure,
    payload: error,
});

const categoriesByNameFetch = () => ({
    type: types.categoriesFetch,
});

const categoriesByNameFetchSuccess = (categories) => ({
    type: types.categoriesFetchSuccess,
    payload: categories,
});

const categoriesByNameFetchFailure = (error) => ({
    type: types.categoriesFetchFailure,
    payload: error,
});

const addCategorySuccess = (category) => ({
    type: types.addCategorySuccess,
    payload: category,
});

const addCategoryFailure = (error) => ({
    type: types.addCategoryFailure,
    payload: error,
});

const updateCategorySuccess = (category) => ({
    type: types.updateCategorySuccess,
    payload: category
});

const updateCategoryFailure = (error) => ({
    type: types.updateCategoryFailure,
    payload: error
});

export const fetchCategories = (id_customer, token, offset = 0, limit = 5) => {
    return (dispatch) => {
        dispatch(categoriesFetch());
        try {
            client.get(
                `/categories/${id_customer}`,
                {
                    params: {
                        offset,
                        limit
                    },
                    headers: {Authorization: `Bearer ${token}`},
                }
            ).then(({data}) => {
                console.log(data)
                dispatch(categoriesFetchSuccess(data));
            })
        } catch (error) {
            dispatch(categoriesFetchFailure(error.message));
        }
    };
};

export const fetchCategoriesByName = (name, id_customer, token) => {
    return async (dispatch) => {
        dispatch(categoriesByNameFetch());
        try {
            const response = await client.get(
                `/categories/name/${id_customer}?name=${encodeURIComponent(
                    name
                )}`,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            if (response.data.items.length === 0) {
                alert("No se han encontrado categorías");
                dispatch(fetchCategories(id_customer, token));
            } else {
                dispatch(categoriesByNameFetchSuccess(response.data));
            }
        } catch (error) {
            alert("Error: No se han encontrado categorías");
            dispatch(categoriesByNameFetchFailure(error.message));
        }
    };
};

export const addCategory = (category, token) => {
    return async (dispatch) => {
        try {
            const response = await client.post(
                `/categories/`,
                category,
                {
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            dispatch(addCategorySuccess(response.data));
        } catch (error) {
            dispatch(addCategoryFailure(error.message));
        }
    };
};

export const updateCategory = (id, category, token) => {
    return async (dispatch) => {
        try {
            const response = await client.patch(
                `/categories/${id}`, category,
                {
                    headers: {Authorization: `Bearer ${token}`},
                },
            );
            dispatch(updateCategorySuccess(response.data));
            dispatch(fetchCategories(category.id_customer, token));
        } catch (error) {
            dispatch(updateCategoryFailure(error.message));
        }
    };
};
